import { useState } from 'react';
import PropTypes from 'prop-types';

const COLOR_FIELDS = [
  { key: 'primaryColor', label: 'Primary Node' },
  { key: 'primaryTextColor', label: 'Primary Text' },
  { key: 'lineColor', label: 'Line' },
  { key: 'background', label: 'Background' }
];

const TEXT_FIELDS = [
  { key: 'fontFamily', label: 'Font Family', placeholder: 'trebuchet ms, verdana, arial' },
  { key: 'fontSize', label: 'Font Size', placeholder: '16px' }
];

function StyleControls({ values, onValueChange, onApply, onReset, isApplyDisabled }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleColorChange = (key) => (event) => {
    onValueChange(key, event.target.value.toUpperCase());
  };

  const handleTextChange = (key) => (event) => {
    onValueChange(key, event.target.value);
  };

  return (
    <div className="style-controls card">
      <div className="style-controls__header" onClick={() => setIsExpanded(!isExpanded)} style={{ cursor: 'pointer' }}>
        <h4>
          <span style={{ marginRight: 'var(--space-8)' }}>{isExpanded ? '▼' : '▶'}</span>
          Diagram Styling
        </h4>
        <div className="style-controls__buttons" onClick={(e) => e.stopPropagation()}>
          <button
            className="btn btn--secondary btn--sm"
            type="button"
            onClick={onReset}
          >
            Reset
          </button>
          <button
            className="btn btn--primary btn--sm"
            type="button"
            onClick={onApply}
            disabled={isApplyDisabled}
          >
            Apply
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className="style-controls__grid">
          {COLOR_FIELDS.map(({ key, label }) => (
            <label key={key} className="style-controls__field">
              <span>{label}</span>
              <input
                type="color"
                value={values[key] || '#000000'}
                onChange={handleColorChange(key)}
              />
            </label>
          ))}

          {TEXT_FIELDS.map(({ key, label, placeholder }) => (
            <label key={key} className="style-controls__field">
              <span>{label}</span>
              <input
                type="text"
                value={values[key] || ''}
                onChange={handleTextChange(key)}
                placeholder={placeholder}
              />
            </label>
          ))}
        </div>
      )}
    </div>
  );
}

StyleControls.propTypes = {
  values: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  isApplyDisabled: PropTypes.bool
};

StyleControls.defaultProps = {
  isApplyDisabled: false
};

export default StyleControls;